enum ArticlePhotosWidgetContext {
  DEFAULT = 'default',
  PHOTOS_ONLY = 'photos-only',
}

export { ArticlePhotosWidgetContext }
